import { ResourceBuilder } from '../../core/resource-builder'
import type Model from './model'

type WebinarsRequestsConfig = {
  list: {
    request: void
    response: Model[]
  }
  get: {
    request: {
      id: number
    }
    response: Model
  }
  create: {
    request: Omit<Model, 'id' | 'chatters' | 'link' | 'webinar_notifications'>
    response: void
  }
  delete: {
    request: void
    response: void
  }
  update: {
    request: Partial<Omit<Model, 'id' | 'chatters' | 'webinar_notifications'>>
    response: void
  }
}

export default new ResourceBuilder<WebinarsRequestsConfig>('webinars')
